<div id="bulletin" class="mt-5" data-scroll>
    <div class="container">
        <div class="row bullet bg-light">
            <div class="col-5 col-md-4 col-xl-2 bullet-1">
                <h5 class="text-center">Announcements</h5>
                <span class=""></span>
            </div>
            <div class="col-7 col-md-8 col-xl-10 bullet-2 my-auto">
                <marquee behavior="scroll" direction="left" class="bulletinMarque" onmouseenter="this.stop();"
                    onmouseleave="this.start();">
                    <!-- Content will be injected by TS -->
                </marquee>
            </div>
        </div>
    </div>
</div>